var AriesComponent = require('libs/aries-component');
var propertyRecordsSearchToolBarTemplate = require('templates/propertyRecordsSearchToolBar.hbs');
var propertyRecordsSearchToolBarAssociateTemplate = require('templates/propertyRecordsSearchToolBar-associate.hbs');

/**
 * Property Records Component, primarly used in Search Results.
 * This component displays the property records returned for a search results
 */
AriesComponent.create({
	type: 'propertyRecordsSearchToolBar',
	// Needed when subscribed to Pub-Sub events
	subscribe: {
		'PROPERTY_RECORDS_VIEW_CHANGE': 'onViewChange',
		'TOGGLE_FOOTER_FILTER' : 'toggleFooterOnFilter'
	},
	template: {
		'propertyRecordsSearchToolBar': propertyRecordsSearchToolBarTemplate,
		'propertyRecordsSearchToolBar-associate': propertyRecordsSearchToolBarAssociateTemplate
	},
	events: {
		'click .m-dropdown': 'dropDownMouseHandler',
		'keypress .m-dropdown': 'dropKeyBoradHandler',
		'blur .m-dropdown-list': 'onMenuBlurHandler',
		'click .m-dropdown .m-dropdown-option': 'onMemuItemSelected',
		'click .js-toggle-view': 'changeView'
	},

	bindEvents: function() {
		this.refinedSearchUrl = this.$el.data('refine-search-url');
		$(window).on('resize', this.slideBorder.bind(this));
		this.slideBorder();
	},

	/**
	 * Dropdown menu mouse event handler
	 */
	dropDownMouseHandler: function(evt) {
		if( !$(evt.target).hasClass('m-dropdown-option') )
			this.openDropDown(evt.currentTarget);
	},
	
	/**
	 * Dropdown menu keyborad event handler
	 */
	dropKeyBoradHandler: function(evt) {
		var charCode = evt.which || evt.key.charCodeAt(0);
		if( 13 === charCode || 32 === charCode ) {
			evt.preventDefault();
			if( $(evt.target).hasClass('m-dropdown-option') )
				this.onMemuItemSelected({currentTarget: evt.target});
			else
				this.openDropDown(evt.currentTarget);
		}	
	},

	/**
	 * Event handler for sort dropdown value selection
	 */
	onMemuItemSelected: function(evt) {
		var $menuOption = $(evt.currentTarget);
		if( !$menuOption.hasClass('current-value') ) {
			var paramName = $menuOption.parents('.m-dropdown').data('name');
			var value = $menuOption.data('value');
			this.setFilter(paramName, value);
		}
		this.hideMenu($menuOption);
	},

	/**
	 * On Blur Menu Event Handler, helps hide the menu when focus is lost
	 */
	onMenuBlurHandler: function(evt) {
		if(!evt.relatedTarget || !$(evt.currentTarget).find(evt.relatedTarget).exists())
			this.hideMenu(evt.currentTarget);
	},

	/**
	 * Hide the menu based on any given item in the menu or menu it self
	 */
	hideMenu: function(menu) {
		var $menu = $(menu);
		if( !$menu.hasClass('.m-dropdown') )
			$menu = $menu.parents('.m-dropdown');
		$menu.removeClass('in-focus');			
	},

	/**
	 * Update the filter value in the query params
	 */
	setFilter: function(name, value) {
		var location = window.location;
		var queryParams = {};
		if( location.search ) {
			location.search.substr(1).split('&').forEach(function findParam(param) {
				var params = param.split('=');
				queryParams[params[0]] = params[1]
			})
		}
		queryParams[name] = value;
		var filterDropdownUrl = window.location.origin + this.refinedSearchUrl;
		var userAgentDetails = window.navigator.userAgent;
		var ieBrowser = userAgentDetails.indexOf("MSIE ");

		if (ieBrowser > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			var actualUrl = window.location.href;
			var refinedUrl = '';
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				refinedUrl = this.setIEUrl(actualUrl, Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
				actualUrl = refinedUrl;
			}
			window.location = refinedUrl;
		}
		else  // If another browser, return 0
		{
			var filterurl = new URL(filterDropdownUrl);
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				filterurl.searchParams.set(Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
			}
			window.location = filterurl.href;
		}
	},

	setIEUrl: function(url, key, val) {
		var reExp = new RegExp("[\?|\&]"+ key + "=[0-9a-zA-Z\_\+\-\|\.\,\;]*");
		if(reExp.test(url)) {
			// update
			var reExp = new RegExp("[\?&]" + key + "=([^&#]*)");
			var delimiter = reExp.exec(url)[0].charAt(0);
			url = url.replace(reExp, delimiter + key + "=" + val);
		} else {
			// add
			var newParam = key + "=" + val;
			if(!url.indexOf('?')){url += '?';}
			if(url.indexOf('?') > -1){
				var urlparts = url.split('#');
				url = urlparts[0] +  "&" + newParam +  (urlparts[1] ?  "#" +urlparts[1] : '');
			} else {
				url += "?" + newParam;
			}
		}
		//window.location = url;
		return url;
	},

	/**
	 * Open the menu
	 */
	openDropDown: function(menu) {
		var $menu = $(menu);
		var $list = $menu.find('.m-dropdown-list');

		if( $menu.hasClass('in-focus') )
			$menu.removeClass('in-focus');
		else {
			$menu.addClass('in-focus');
			$list.find('.m-dropdown-option').first().focus();
		}
	},

	changeView: function(event) {
		var _self = this,
		currentEl = $(event.currentTarget),
		toggleView = currentEl.data('view'), 	   
		viewOptions = _self.$el.data('view-options');
		if(toggleView === 'map'){
			$('.brand-drawer-container').hide();
		} else {
			$('.brand-drawer-container').show();
		}
		if(currentEl.hasClass('is-active') && _self.$el.data('newMultiRateExperience')) {
			return;
		}
		_self.selectedView(event);
		if(toggleView !== ""){
			_self.makeAjaxCall({
				method: viewOptions.method,
				url: viewOptions.url,
				data: JSON.stringify({
					'sessionToken': this.getSessionToken(),
					'searchResultViewType': toggleView
				})
			});
			// TODO: check to see if the current view is same as the one to toggle
			_self.pubsub.publish('PROPERTY_RECORDS_SWITCH_VIEW', [toggleView]);
			event.preventDefault();
		}
	},

	selectedView : function(event){
		var _self = this;
		var currentEl = $(event.currentTarget);
		_self.$el.find('.js-toggle-view').removeClass('is-active');
		currentEl.addClass('is-active');
		currentEl.find('.js-selected-view').attr('aria-live', 'polite');
		currentEl.find('.js-selected-view').attr('aria-label', currentEl.data('view')+' '+_self.$el.data('selectedLabel'));
		currentEl.find('.l-view-label').attr('aria-hidden', 'true');
		_self.slideBorder();
		_self.$el.find('.js-toggle-view:not(.is-active) .js-selected-view').removeAttr('aria-label aria-live');
		_self.$el.find('.js-toggle-view:not(.is-active) .l-view-label').removeAttr('aria-hidden');
	},

	slideBorder : function(){
		var _self = this;
		var selectedTab = _self.$el.find('.js-toggle-view.is-active');
		var isRTL = $(document.documentElement).attr('dir') === 'rtl';
		if(selectedTab.length>0){
			var pos = isRTL ? (selectedTab.position().left+selectedTab.outerWidth())-_self.$el.width() : selectedTab.position().left;
			var currentWidth = selectedTab.innerWidth();
			_self.$el.find('.js-toggle-border').css({
				'display':'block',
				'transform': 'translate3d('+pos+'px'+',0,0)',
				'width': currentWidth
			});
			_self.$el.find(".l-toggle-border").css({
				'visibility': 'visible'
			});
		}
	},

	/**
	 * Pub-Sub handler for PROPERTY_RECORDS_VIEW_CHANGE
	 */
	onViewChange: function(viewType) {
		var _self = this;
		var $views = _self.$el.find('[data-view]');
		var $setTo = $views.filter('[data-view="' + viewType + '"]');
		var isNewMultiRateExperience = _self.$el.data('newMultiRateExperience');
		if(viewType === 'list' && _self.$el.find('.l-container-width')) {
			$('.js-list-container').addClass('hide-map-property-list');
		}
		if(isNewMultiRateExperience){
			$views.not($setTo).removeClass('is-active');
			$setTo.addClass('is-active');
		}else{
			$views.not($setTo).removeClass('is-hidden').addClass('is-active');
			$setTo.addClass('is-hidden').removeClass('is-active');
		}	
	},
	toggleFooterOnFilter : function(showFooter){
		var footer = $('.m-footer');
		this.$el.find('.js-toggle-view').each(function(){
			if($(this).hasClass('is-active') && 'map' === $(this).data('view')){
				showFooter ? footer.show(): footer.hide();
				return false;
			}
		});
	}
});  